import debounce from "lodash/debounce";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import InputColor from "react-input-color";
import { hexToWindowsColor, windowsColorToHex } from "../../utils/colors";

const ColorEditor = forwardRef(
  ({ defaultValue, updateData, ...props }, ref) => {
    const [color, setColor] = useState(windowsColorToHex(Number(defaultValue)));
    const isMounted = useRef(true);

    useEffect(() => {
      console.log(props);

      isMounted.current = true;

      if (!isNaN(defaultValue) && defaultValue >= 0) {
        setColor(windowsColorToHex(Number(defaultValue)));
      }

      return () => {
        isMounted.current = false;
      };
    }, [defaultValue]);

    const debouncedColorChange = useCallback(
      debounce((color) => {
        if (isMounted.current) {
          const colorValue = hexToWindowsColor(color.hex);
          if (colorValue !== defaultValue) {
            updateData(colorValue);
            setColor(color.hex); // Actualiza el estado del color seleccionado
          }
        }
      }, 100),
      [updateData, defaultValue]
    );

    return (
      <div ref={ref} className="flex items-center justify-center w-full">
        <InputColor
          initialValue={color}
          onChange={debouncedColorChange}
          placement="right"
        />
      </div>
    );
  }
);

const ColorCreator = forwardRef((props, ref) => {
  const [color, setColor] = useState({ hex: windowsColorToHex(16777215) }); // Initial color

  const handleColorChange = (color) => {
    setColor(color);
  };

  useImperativeHandle(ref, () => ({
    getFieldValue: () => {
      return hexToWindowsColor(color.hex);
    },
  }));

  return (
    <div ref={ref} className="flex items-center justify-center w-full">
      <InputColor
        initialValue={color.hex}
        onChange={handleColorChange}
        placement="right"
      />
    </div>
  );
});

export const createColorCreator = (
  column,
  attr,
  editorClass,
  ignoreEditable
) => {
  return (
    <ColorCreator
      ref={attr?.ref}
      editorClass={editorClass}
      ignoreEditable={ignoreEditable}
    />
  );
};

export const createColorEditor = (onUpdate, props) => {
  return (
    <ColorEditor ref={props?.attr?.ref} updateData={onUpdate} {...props} />
  );
};
